import { ActionButton } from './ActionButton';

/* eslint-disable deprecation/deprecation */

/**
 * @deprecated This component was experimental and is not longer being developed on, nor will it be supported in the
 * future.
 */
export const CommandButton = ActionButton;
